import mod from "-!./ekpTabPage.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./ekpTabPage.js?vue&type=script&lang=js&external"